import { AppliedCTAFunction } from "../../appliedCTAFunction/AppliedCTAFunction";

export class CachedCTAResource {
  constructor(
    public ctaFunction: AppliedCTAFunction,
    public ctaHtml: string,
  ) {}
}
